import { Edit, SimpleForm } from "react-admin";
import { OrganEventForm } from "./OrganEventForm";
import { SaveOnlyToolbar } from "../../components/SaveOnlyToolbar";
import { useUpdateSubmit } from "../../forms";

const OrganEventEditForm = () => {
	const submit = useUpdateSubmit("organ-events", "Event updated", {
		resource: "organs",
		idColumn: "organ_id",
		view: "show",
		subPath: "events",
	});

	return (
		<SimpleForm onSubmit={submit} toolbar={<SaveOnlyToolbar />}>
			<OrganEventForm />
		</SimpleForm>
	);
};

export const OrganEventEdit = () => {
	return (
		<Edit title="Update event">
			<OrganEventEditForm />
		</Edit>
	);
};
